import React from 'react';
import { compose, lifecycle, withState, withPropsOnChange, withHandlers } from 'recompose';
import { reduxForm, Field } from 'redux-form';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import { TextField, Select } from 'redux-form-material-ui';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';
import { renderToggleInput } from '../../components/forms/Toggle';
import { FormControl, InputLabel, MenuItem } from '@material-ui/core';
import { getQRcodeVersions, updateQRcode } from './_api';
import { isArray } from 'lodash';
import { withSnackbar } from 'notistack';
import withLoader from '../app/withLoader';

const styles = (theme) => ({});

const enhance = compose(
  withStyles(styles),
  withSnackbar,
  withLoader,
  withRouter,
  withState('initialValues', 'setInitialValues', {}),
  withState('QRcodes', 'setQRcodes', {}),
  withHandlers({
    onSubmit: ({enqueueSnackbar, history, toggleLoader}) => async (values) => {
      toggleLoader();
      const resp = await updateQRcode(values.qr);
      toggleLoader(false);
      if(resp.status === 200) {
        enqueueSnackbar('Verze QR kódu byla úspěšně změněna', { variant: 'success' });
        history.push('/');
      } else {
        enqueueSnackbar('Chyba při změně QR kódu', { variant: 'error' });
      }
    },
  }),
  withPropsOnChange(['QRcodes'], ({ QRcodes }) => {
    return {
      fields: [
        {
          name: 'qr',
          label: 'Použitá verze',
          select: true,
          options: isArray(QRcodes) ? QRcodes.map((qr) => ({ value: qr, label: qr })) : [],
        },
      ],
    };
  }),
  reduxForm({ form: 'changeQRForm', enableReinitialize: true }),
  lifecycle({
    async componentDidMount() {
      const qrCodes = await getQRcodeVersions();
      this.props.setQRcodes(qrCodes.allVersions);
      this.props.setInitialValues({ qr: qrCodes.actualVersion });
    },
  }),
);

const required = (value) => (value || value === false ? undefined : 'Vyžadováno');

const renderField = (field) => {
  if (field.select) {
    return (
      <Field
        name={field.name}
        component={(props) => (
          <FormControl style={{ width: '100%' }}>
            <InputLabel htmlFor={field.name}>{field.label}</InputLabel>
            <Field name={field.name} component={Select} placeholder={field.name}>
              {field.options.map((item2) => (
                <MenuItem key={item2.value} value={item2.value}>
                  {item2.label}
                </MenuItem>
              ))}
            </Field>
          </FormControl>
        )}
      />
    );
  } else {
    return (
      <Field
        name={field.name}
        type="text"
        component={field.boolean ? renderToggleInput : TextField}
        label={field.label}
        validate={[required]}
        fullWidth={true}
      />
    );
  }
};

// Response
// {"name":"Rezervační systém - vývoj a test","address":"Ulice 1, Město, PSČ","identificationNumber":"IČO","taxIdentificationNumber":"DIČ","phone":"739801060 (731164318)","mail":"vas@email.cz","web":"https://www.vasweb.cz","options":{"endOfSeason":"30.4.","printFormat":"PAPER_ROLL80x297","smtp":{"authorization":true,"user":"info@sportjezek.cz","password":"h.g?qprI#A`FV`r@:Dd8","host":"wes1-smtp.wedos.net","port":587,"sender":"info@sportjezek.cz","ssl":true,"tls":false,"contactSubject":"Helpdesk požadavek od zákazníka: Sport Ježek","contactEmail":"zavoralm@gmail.com","options":{"sendEnabled":true,"rentalConditionsPdf":"data/email/Vseobecne-podminky-pujcovny-ZIMA.pdf","emailTextTemplate":"data/email/emailTexts.json"}}}}

export default enhance(({ classes, handleSubmit, setAddUser, history, fields }) => (
  <form className={classes.form} onSubmit={handleSubmit}>
    <Grid container spacing={24}>
      {fields.map((field) => (
        <Grid item key={field.name} xs={3}>
          {renderField(field)}
        </Grid>
      ))}
    </Grid>
    <div style={{ margin: 20 }}>
      <Button type="submit" variant="contained" color="primary" className={classes.submit}>
        Uložit
      </Button>
      <Button variant="contained" color="secondary" onClick={() => history.push('/')}>
        Zrušit
      </Button>
    </div>
  </form>
));



// WEBPACK FOOTER //
// ./src/modules/account/changeQRForm.js